import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    Stack,
    Alert,
    Link,
    useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../api/authAPI";

export default function ForgotPassword() {
    const theme = useTheme();
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setError("");

        try {
            const response = await forgotPassword(email);
            console.log(response.data, "response")

            if (response.data?.CodeDeliveryDetails) {
                setMessage("Reset code sent! Redirecting...");
                setTimeout(() => navigate("/resetPassword"), 1000);
            } else {
                setError("Unable to send password reset email. Try again.");
            }
        } catch (err) {
            console.error(err);
            setError("Email not found or invalid. Please try again.");
        }
    };

    return (
        <Box>
            {/* Logo */}
                  <Box textAlign="center" mb={3}>
                    <Box
                      component="img"
                      src="/csepathshala.png"
                      alt="Topperhub"
                      sx={{
                        height: 56,
                        mb: 1,
                        filter:
                          theme.palette.mode === "dark"
                            ? "brightness(1.1)"
                            : "none",
                      }}
                    />
                  </Box>
            <Typography
                variant="h4"
                fontWeight={500}
                textAlign="center"
                mb={3}
                color={theme.palette.text.primary}
            >
                Forgot Password
            </Typography>

            <Typography
                variant="body1"
                textAlign="center"
                mb={4}
                color={theme.palette.text.secondary}
            >
                Enter your registered email to receive a reset code
            </Typography>

            <form onSubmit={handleSubmit}>
                <Stack spacing={3}>
                    <TextField
                        label="Email"
                        type="email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "12px",
                            },
                        }}
                    />

                    <Button
                        variant="contained"
                        type="submit"
                        fullWidth
                        sx={{
                            borderRadius: "12px",
                            paddingY: 1.2,
                            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "16px",
                            color: theme.palette.primary.contrastText,
                        }}
                    >
                        Send Reset Code
                    </Button>

                    {message && (
                        <Alert severity="success" sx={{ borderRadius: "10px" }}>
                            {message}
                        </Alert>
                    )}

                    {error && (
                        <Alert severity="error" sx={{ borderRadius: "10px" }}>
                            {error}
                        </Alert>
                    )}

                    <Typography textAlign="center" mt={1} color={theme.palette.text.secondary}>
                        Remember your password?{" "}
                        <Link
                            underline="none"
                            sx={{ cursor: "pointer", color: theme.palette.primary.main }}
                            onClick={() => navigate("/login")}
                        >
                            Go back to Login
                        </Link>
                    </Typography>
                </Stack>
            </form>
        </Box>
    );
}
